import React, { useState } from "react";
import FormModal from "../../../components/FormModal";
import Button from "../../../components/Form/Button";
import { useNavigate } from "react-router-dom";
import { getCurrentUser, cakePhpURL } from "../../../api";
import checkCircle from "../../../assets/images/check_circle.svg";
import Loader from "../../../components/Loader";

const SuccessSubmitModal = ({ show, handleClose, autoUrl, user }) => {
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  console.log("User", user);
  const logOut = async () => {
    if (
      getCurrentUser() === null ||
      getCurrentUser() === undefined ||
      getCurrentUser() === ""
    ) {
      navigate("/login");
    } else {
      window.open(cakePhpURL + "users/logout", "_self");
    }
  };

  const dashboard = async () => {
    window.open(autoUrl, "_self");
  };

  return (
    <>
      {!loading && (
        <FormModal
          show={show}
          onClose={handleClose}
          size="md"
          backdrop="static"
          modalClassName="successModal"
        >
          <div className="success-modal-container">
            <div className="success-modal-wrapper">
              <img src={checkCircle} alt="icon" />
              <p>
                You've successfully completed the onboarding process. Let's get
                started!
              </p>
            </div>
            <div className="my-3">
              {/* {user?.is_signatory_user ? (
                ""
              ) : (
                <Button
                  type="button"
                  className="btn-outline-primary me-2"
                  onClick={() => logOut()}
                >
                  Log out
                </Button>
              )} */}
              <Button
                type="button"
                className="btn-primary text-white"
                onClick={() => dashboard()}
              >
                GO TO DASHBOARD
              </Button>
            </div>
          </div>
        </FormModal>
      )}
      {loading && <Loader />}
    </>
  );
};

export default SuccessSubmitModal;
